export const BoxCharacters = {
  VERTICAL_LINE: '│',
  RIGHT_TOP_ELBOW: '┌╴',
  RIGHT_BOTTOM_ELBOW: '└╴',
  LEFT_BOTTOM_ELBOW: '╶┘',
  RIGHT_TEE: '├╴',
  LEFT_TEE: '╶┤',
  EMPTY: '',
} as const;

export type BoxChar = (typeof BoxCharacters)[keyof typeof BoxCharacters];
